export default __webpack_public_path__ + "static/media/products.e00c8b1c.svg";